import { AxiosError } from 'axios';

/** responseType: 'arraybuffer' Error를 AxiosError로 변환 */

const useArrayBufferErrorHandler = (onError?: (e: AxiosError) => void) => {
  return (error: AxiosError) => {
    if (error.response && error.response.data instanceof ArrayBuffer) {
      const decodedString = new TextDecoder().decode(error.response.data);
      try {
        const parsedError = JSON.parse(decodedString);
        error.response.data = parsedError;
      } catch (jsonError) {
        console.error('Error parsing the error response:', jsonError);
      }
    }
    if (onError) onError(error);
  };
};
export default useArrayBufferErrorHandler;
